import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { Avatar, ExternalLink } from '@infl-ts/ui-advocate-components';
import { useToggle } from '@infl-ts/util-hooks';
import { resolveNextViteImage } from '@infl-ts/util-resolve-next-vite-image';
import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import { Alert, Box, Button, Card, Dialog, DialogActions, DialogTitle, styled, TextField, Typography, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextTruncate from 'react-text-truncate';
import inflLogo from './influitive-logo.png';
import { validateCharCount } from './share-modal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MAX_LENGTH = 1300;
var StyledImage = styled('img')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  object-fit: contain;\n"])));

var PreviewWrapper = function PreviewWrapper(_ref) {
  var url = _ref.url,
      previewTitle = _ref.previewTitle,
      children = _ref.children;
  return url ? /*#__PURE__*/_jsx(ExternalLink, {
    sx: {
      display: 'block',
      mt: 1,
      '&:hover': {
        textDecoration: 'none'
      }
    },
    href: url !== null && url !== void 0 ? url : '#',
    rel: "noreferrer noopener",
    target: "_blank",
    title: previewTitle ? "Visit ".concat(previewTitle) : '',
    children: children
  }) : /*#__PURE__*/_jsx(Box, {
    sx: {
      mt: 1
    },
    children: children
  });
};

var LinkedInModal = function LinkedInModal(_ref2) {
  var message = _ref2.message,
      previewImageUrl = _ref2.previewImageUrl,
      previewTitle = _ref2.previewTitle,
      minimumCharacters = _ref2.minimumCharacters,
      url = _ref2.url,
      _onClose = _ref2.onClose,
      onShare = _ref2.onShare,
      sharing = _ref2.sharing;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isTruncated = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      setTruncated = _useToggle2$.on,
      clearTruncated = _useToggle2$.off;

  var _useState = useState(message),
      internalMessage = _useState[0],
      setInternalMessage = _useState[1];

  var _useToggle3 = useToggle(),
      _useToggle4 = _slicedToArray(_useToggle3, 2),
      isEditMode = _useToggle4[0],
      setEditMode = _useToggle4[1].on;

  var _useToggle5 = useToggle(),
      _useToggle6 = _slicedToArray(_useToggle5, 2),
      minCharError = _useToggle6[0],
      _useToggle6$ = _useToggle6[1],
      setCharError = _useToggle6$.on,
      removeCharError = _useToggle6$.off;

  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var isMessageValid = validateCharCount(minimumCharacters);
  useEffect(function () {
    internalMessage.length >= MAX_LENGTH ? setTruncated() : clearTruncated();
    setInternalMessage(internalMessage.slice(0, MAX_LENGTH));
  }, [internalMessage, clearTruncated, setTruncated]);
  return /*#__PURE__*/_jsxs(Dialog, {
    maxWidth: "md",
    fullWidth: true,
    open: true,
    onClose: function onClose(_, reason) {
      return reason !== 'backdropClick' && _onClose();
    },
    "aria-labelledby": "Share on LinkedIn",
    "data-element": "Dialog",
    "data-component": "LinkedInModal",
    "data-source-file": "linkedin-modal.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pr: 4,
        pl: 2
      },
      "data-element": "Box",
      "data-component": "LinkedInModal",
      "data-source-file": "linkedin-modal.tsx",
      children: [/*#__PURE__*/_jsx(DialogTitle, {
        sx: {
          fontSize: function fontSize(t) {
            return t.typography.h3.fontSize;
          }
        },
        "data-element": "DialogTitle",
        "data-component": "LinkedInModal",
        "data-source-file": "linkedin-modal.tsx",
        children: t('Share on LinkedIn')
      }), /*#__PURE__*/_jsx(CloseIcon, {
        sx: {
          cursor: 'pointer'
        },
        onClick: _onClose,
        "data-element": "CloseIcon",
        "data-source-file": "linkedin-modal.tsx"
      })]
    }), isTruncated && /*#__PURE__*/_jsx(Alert, {
      severity: "warning",
      children: t("Your text has been truncated, because it is longer than the {{maxLength}} characters limit.\n          This includes the shortened version of the share URL.", {
        maxLength: MAX_LENGTH
      })
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        mx: 4,
        my: 2
      },
      "data-element": "Box",
      "data-source-file": "linkedin-modal.tsx",
      children: /*#__PURE__*/_jsxs(Card, {
        "data-element": "Card",
        "data-source-file": "linkedin-modal.tsx",
        children: [/*#__PURE__*/_jsxs(Box, {
          sx: {
            mx: 2,
            mt: 2
          },
          "data-element": "Box",
          "data-source-file": "linkedin-modal.tsx",
          children: [/*#__PURE__*/_jsx(Box, {
            sx: {
              display: 'flex',
              justifyContent: 'space-between'
            },
            "data-element": "Box",
            "data-source-file": "linkedin-modal.tsx",
            children: /*#__PURE__*/_jsxs(Box, {
              sx: {
                display: 'flex',
                gap: 2
              },
              "data-element": "Box",
              "data-source-file": "linkedin-modal.tsx",
              children: [/*#__PURE__*/_jsx(Avatar, {
                size: isMobile ? 'small' : 'medium',
                disabledPopover: true,
                member: {
                  id: '0',
                  name: 'Unknown'
                },
                "data-element": "Avatar",
                "data-source-file": "linkedin-modal.tsx"
              }), /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx(Typography, {
                  component: "div",
                  variant: "h4",
                  "data-element": "Typography",
                  "data-source-file": "linkedin-modal.tsx",
                  children: t('Your name')
                }), ' ', /*#__PURE__*/_jsx(Typography, {
                  component: "div",
                  variant: "body2",
                  sx: {
                    color: function color(t) {
                      return t.palette.text.secondary;
                    }
                  },
                  "data-element": "Typography",
                  "data-source-file": "linkedin-modal.tsx",
                  children: t('Your Title at Company')
                }), /*#__PURE__*/_jsx(Typography, {
                  component: "div",
                  variant: "body2",
                  sx: {
                    color: function color(t) {
                      return t.palette.text.secondary;
                    }
                  },
                  "data-element": "Typography",
                  "data-source-file": "linkedin-modal.tsx",
                  children: "1h"
                })]
              })]
            })
          }), isEditMode ? /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              flexDirection: 'column'
            },
            children: [/*#__PURE__*/_jsx(Typography, {
              color: minCharError ? 'error' : '',
              sx: {
                alignSelf: 'flex-end'
              },
              children: t("messageCharacterText", {
                count: internalMessage.length
              })
            }), /*#__PURE__*/_jsx(TextField, {
              sx: {
                mt: 1,
                width: 1
              },
              multiline: true,
              autoFocus: true,
              value: internalMessage,
              error: minCharError,
              onChange: function onChange(e) {
                if (minCharError && isMessageValid(e.target.value)) removeCharError();
                setInternalMessage(e.target.value);
              }
            })]
          }) : /*#__PURE__*/_jsx(Typography, {
            sx: {
              overflowWrap: 'anywhere'
            },
            children: internalMessage
          })]
        }), /*#__PURE__*/_jsxs(PreviewWrapper, {
          url: url,
          previewTitle: previewTitle,
          "data-element": "PreviewWrapper",
          "data-source-file": "linkedin-modal.tsx",
          children: [url || previewImageUrl ? /*#__PURE__*/_jsx(StyledImage, {
            src: previewImageUrl || resolveNextViteImage(inflLogo)
          }) : null, url && /*#__PURE__*/_jsxs(Box, {
            sx: {
              p: 2,
              backgroundColor: function backgroundColor(t) {
                return t.palette.secondary.background;
              }
            },
            children: [previewTitle && /*#__PURE__*/_jsx(Typography, {
              component: "div",
              sx: {
                overflow: 'hidden',
                overflowWrap: 'anywhere'
              },
              variant: "h4",
              color: "textPrimary",
              children: /*#__PURE__*/_jsx(TextTruncate, {
                line: 2,
                truncateText: "...",
                text: previewTitle
              })
            }), url && /*#__PURE__*/_jsx(Typography, {
              component: "div",
              sx: {
                overflow: 'hidden',
                overflowWrap: 'anywhere'
              },
              variant: "body2",
              color: "textSecondary",
              children: /*#__PURE__*/_jsx(TextTruncate, {
                line: 1,
                truncateText: "...",
                text: url
              })
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs(DialogActions, {
      sx: {
        mr: 3,
        mb: 2
      },
      "data-element": "DialogActions",
      "data-source-file": "linkedin-modal.tsx",
      children: [!isEditMode && /*#__PURE__*/_jsx(Button, {
        sx: {
          mr: 1
        },
        variant: "outlined",
        onClick: setEditMode,
        children: t('Edit')
      }), /*#__PURE__*/_jsx(LoadingButton, {
        loading: sharing,
        loadingIndicator: t('Posting...'),
        variant: "contained",
        onClick: function onClick() {
          return isMessageValid(internalMessage) ? onShare(internalMessage) : setCharError();
        },
        "data-element": "LoadingButton",
        "data-source-file": "linkedin-modal.tsx",
        children: t('Post')
      })]
    })]
  });
};

export default LinkedInModal;